export default "__VITE_ASSET__c7694a41__"